import { useState } from 'react'

import { CURRENT_COUNTRY_CANADA } from 'shared/constants'
import { CountryStateSelects } from 'shared/components/CountryStateSelects'

const useCountryState = () => {
    const [selectedCountry, setSelectedCountry] = useState(CURRENT_COUNTRY_CANADA)
    const [selectedState, setSelectedState] = useState(null)

    const countryStateComponent = isNewUser => (
        <CountryStateSelects
            isNewUser={isNewUser}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            selectedState={selectedState}
            setSelectedState={setSelectedState}
        />
    )
    return { countryStateComponent, selectedCountry, setSelectedCountry, selectedState, setSelectedState }
}

export default useCountryState
